import { render, staticRenderFns } from "./leifeng-orderlist.vue?vue&type=template&id=008674de&scoped=true&"
import script from "./leifeng-orderlist.vue?vue&type=script&lang=js&"
export * from "./leifeng-orderlist.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-orderlist.vue?vue&type=style&index=0&id=008674de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008674de",
  null
  
)

export default component.exports